<template>
<div class="menuBody" >
    <BillManTree @AllData="getMsgFormSon" @NodeData="NodeData" />
        <BillStorageDialog :param="diaLogData" ref="BillStorageDialog"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                票据列表
            </div>
             <div style="width:150px;float:left;margin-right:15px">
                    <el-select  clearable v-model="BillTypevalue" placeholder="请选择票据类型"  size="small" @change="ChargeBillType" >
                        <el-option v-for="item in BillTypeList" :key="item.BillTypevalue" :label="item.BillTypelabel" :value="item.BillTypevalue"></el-option>
                    </el-select>
            </div>
             <div style="width:150px;float:left;margin-right:15px">
                    <el-select  clearable v-model="employval" placeholder="请选择使用状态"  size="small" @change="ChargeBillType" >
                        <el-option v-for="item in employ" :key="item.employval" :label="item.employlab" :value="item.employval"></el-option>
                    </el-select>
            </div>
               <div style="width:150px;float:left;margin-right:15px">
                 <el-input placeholder="请输入票据本编号" size="small" @blur="BillNum()"   v-model="BillNumber"></el-input>
              </div>
               <div style="width:220px;float:left;margin-right:15px">
                   <el-date-picker
                      size="small"
                      style="width:220px;float:left;"
                      v-model="DateTime"
                      type="daterange"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="BillDateTime()">
                    </el-date-picker>
              </div>
             <div style="float:left;">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;"  v-Jurisdiction="'expense:web:bm:bwo:selectListByPage'"  @click="Inquire()">查询</el-button>
            </div>

            <el-table  :data="tableData" v-loading="loading"   @selection-change="BillNucleu" 
            style="overflow-y: scroll;float:right;margin-top:30px" 
            row-key="id"  tooltip-effect="light"   :default-expand-all="false" :stripe="true"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}" :tree-props="{children: 'children'}">
    <el-table-column type="selection" width="55"></el-table-column>
    <el-table-column show-overflow-tooltip prop="groupNo" label="票据本（簿）编号" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="typeName" label="票据类型" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="inDateTime" label="入库时间"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="useDateTime" label="领用时间"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="startEnd" label="票据号码范围" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="everyNums" label="份数" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="openInvoice" label="已开票数"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="romeInvoice" label="作废票数"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="unuserd" label="未作用数"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="sumMoney" label="开票金额合计" ></el-table-column>
    <el-table-column  fixed="right" label="查看" >
     <template slot-scope="scope">
          <el-button @click="Details(scope.row)" type="primary" icon="el-icon-view"  v-Jurisdiction="'expense:web:bm:bwo:getDetailList'" circle size="small" title="详情"></el-button>
        </template>
    </el-table-column>
  </el-table>
        <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import BillStorageDialog from "../common/BillStorageDialog";
import BillManTree from "../common/BillManTree.vue";
export default {
  name: "BillNucleusAlready",
  components: {BillStorageDialog,BillManTree},
  data() {
    return {
      loading:false,
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        BillNumber:"",
        BillStartNum:"",
        BillEndNum:"",
        groupName:"",
        UpCourseCode:"",
        amount:[],
        amountval:"",
      tableData: [],
      options: [{
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }],
        value: '',
        employ:[{
          employval: '1',
          employlab: '是'
        }, {
          employval: '0',
          employlab: '否'
        }],
        employval:"",
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      USERObj:"",
      ProjectMana:"",
      taxRateval:"",
      mangroupId:"",
      BillListo:"",
      BillTypeList:"",
      BillTypevalue:"",
      DateTime:"",
      BilltypeName:"",
    }
  },
  methods: {
    Derive(){
      // 导出
    },
    Details(){
      // 查看详情
    },
      BillNucleu(val){
          // console.log(val)
          this.taxRateval = val
      },
    getMsgFormSon(data){
        // console.log(data)
      this.AllData = data
    },
    ShareList(){
          let PageSize = {
            "page":this.currentPage, // 当前页
            "size":this.pagesize,  // 每页大小
             "createTime":"2019-01-01",
      }
        this.$http.post(this.$requestUrl.POST_NUCLEUS_LIST,PageSize).then((res) => {
          let data = res.data;
          // console.log(data.data)
          if (200 === data.code) {
            for(let val of data.data.records){
                // console.log(val)
                val.startEnd = val.startNum + "--" + val.endNum
            }
            this.total = data.data.total
            this.tableData = data.data.records;
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    NodeData(data){
        // console.log(data,"data")
        this.mangroupId = data.value
        this.mangrouplab = data.label
        this.ShareList()
    },
    ChargeBillType(){
      // console.log(this.BillTypevalue)
      for(let val of this.BillTypeList){
        // console.log(val)
        if(val.BillTypevalue == this.BillTypevalue){
          // console.log(val)
          this.BilltypeName = val.BillTypelabel
        }
      }
    },
    handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pagesize = val
        this.ShareList()
    },
    handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currentPage = val
        this.ShareList()
    },
    Inquire(){
    let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "typeId":this.BillTypevalue,
        "startNum":this.BillStartNum,
        "endNum":this.BillEndNum,
        "groupNo":this.BillNumber
      }
      // console.log(PageSize)
        this.$http.post(this.$requestUrl.POST_STORAGE_LIST,PageSize).then((res) => {
          let data = res.data;
           
          if (200 === data.code) {
            this.tableData = data.data.records;
          } else {
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
      
    },
    getDate(){
	    	let date = new Date();
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
            let hh = new Date().getHours()
            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes():new Date().getMinutes()
            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds():new Date().getSeconds()
	    	let arr = ['星期天','星期一','星期二','星期三','星期四','星期五','星期六'];
	    	let day = date.getDay();
            let time = year+"-"+month+"-"+dates+" "+hh+":"+mf+":"+ss
            this.time = time
            // console.log('今天是：'+ year +'年' + month + '月' + dates + '日' + hh +":"+ mf+":"+ ss + arr[day])
	    },
      // POST_BILLLIST_TYPE
      BillType(){
         this.$http.get(this.$requestUrl.POST_BILLLIST_TYPE).then((res)=>{
          // console.log(res,"res")
          let arr = []
          let date = res.data.data
          // console.log(date)
          for(let val of date){
            // console.log(val)
            let obj = {
              "BillTypevalue":val.typeNum,
              "BillTypelabel":val.name,
            }
            arr.push(obj)
          }
          // console.log(arr)
          this.BillTypeList = arr
        })
      },
      BillDateTime(){
          var d = this.DateTime[0];
          var datetime=d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate();
          var done = this.DateTime[1]
          var datetimeone=done.getFullYear() + '/' + (done.getMonth() + 1) + '/' + done.getDate();
          let obj = {
            "startInDate":datetime,
            "endInDate":datetimeone,
          }
          // console.log(obj)
      },
      BillNum(){
        // console.log(this.BillNumber)
      },
      BillStart(){
        // console.log(this.BillStartNum)
      },
      BillEnd(){
        // console.log(this.BillEndNum)
      }

  },
  mounted() {
    // this.ShareList()
    this.BillType()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
</style>